import { render, staticRenderFns } from "./book-a-chat.vue?vue&type=template&id=6b35f4fe&scoped=true"
import script from "./book-a-chat.vue?vue&type=script&lang=js"
export * from "./book-a-chat.vue?vue&type=script&lang=js"
import style0 from "./book-a-chat.vue?vue&type=style&index=0&id=6b35f4fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b35f4fe",
  null
  
)

export default component.exports